<template>
  <div>
    <Common :rules="rules">
      <template v-slot:context="{ ruleForm }">
        <el-card shadow="never">
          <div class="title">内容编辑</div>
          <el-form-item label="通知标题" prop="title">
            <el-input v-model="ruleForm.title"></el-input>
          </el-form-item>
          <el-form-item label="通知内容" prop="context">
            <el-input type="textarea" v-model="ruleForm.context"></el-input>
          </el-form-item>
        </el-card>
      </template>
    </Common>
  </div>
</template>

<script>
import Common from "./common.vue";
export default {
  components: {
    Common,
  },
  data() {
    return {
      rules: {
        title: [
          {
            required: true,
            message: "请输入标题",
            trigger: "blur",
          },
        ],
        context: [
          {
            required: true,
            message: "请输入内容",
            trigger: "blur",
          },
        ],
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.title {
  height: 50px;
  line-height: 50px;
  font-size: 20px;
  color: #333;
  border-bottom: 1px solid #f4f2f0;
  margin-bottom: 20px;
}
.button {
  margin-top: 20px;
}
</style>
